async function initialise() {
  const { default: elementClosest } = await import('element-closest');
  elementClosest(window);
}

if (window.Element && !Element.prototype.closest) {
  initialise();
}
